<div class="px-3 py-5">
    <div class="theme-container">
        <mat-card class="p-0 o-hidden">
            <div fxLayout="row wrap">
                <div fxFlex="100" fxFlex.gt-sm="50" class="p-0" [style.background-image]="bgImage" class="bg-cover">
                </div>
                <div fxFlex="100" fxFlex.gt-sm="50" class="py-3" ngClass.gt-sm="px-5" ngClass.sm="px-3"
                    ngClass.xs="px-3">
                    <div fxLayout="column" fxLayoutAlign="center center" class="text-center">
                        <h1 class="secondary-font">Un code vous été envoyé</h1>
                        <a mat-button routerLink="/create-utilisateurs" color="accent" class="w-100">
                            Vous n'avez pas de compte ? S'inscrire</a>
                    </div>
                    <form [formGroup]="loginForm" (ngSubmit)="onLoginFormSubmit()">
                        <mat-form-field appearance="outline" class="w-100 mt-2">
                            <mat-icon matPrefix class="mr-1 text-muted">person</mat-icon>
                            <mat-label>indiquer votre code de verification</mat-label>
                            <input matInput placeholder="indiquer votre code de verification" formControlName="code" required>
                            <mat-error *ngIf="loginForm.controls.code.errors?.required">code est requis
                            </mat-error>
                            <mat-error *ngIf="loginForm.controls.code.hasError('minlength')">code isn't long
                                enough, minimum of 6 characters</mat-error>
                        </mat-form-field>
                        <div class="text-center mt-2">
                            <button mat-raised-button color="accent" class="uppercase" type="submit">
                                Save code
                            </button>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between center" class="mt-3">
                            <div class="divider w-100"></div>
                            <h3 class="text-muted ws-nowrap fw-500 p-2">verification</h3>
                            <div class="divider w-100"></div>
                        </div>

                    </form>
                </div>
            </div>
        </mat-card>
    </div>
</div>